import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult, serializeQueryString, SharedModule} from '../../shared';
import {ServerForm, ServerFormUrl} from '../../shared/models/servers';

@Injectable({providedIn: SharedModule})
export class ServersService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'ServersService'; }

  protected get isAnonymous(): boolean { return false; }

  getServers(uuid: string): Observable<SendBackResult<ArrayResponse<ServerForm>>> {
    return this.get<ArrayResponse<ServerForm>>(`/clients/${uuid}/servers`);
  }
  getServersByType(uuid: string , type: string): Observable<SendBackResult<ArrayResponse<ServerForm>>> {
    return this.get<ArrayResponse<ServerForm>>(`/clients/${uuid}/servers?type=${type}`);
  }

  // tslint:disable-next-line:no-any
  getServersURL(uuid: string , serverID: any , serviceType: any): Observable<SendBackResult<ArrayResponse<ServerFormUrl>>> {
   // return this.get<ArrayResponse<ServerFormUrl>>(`/ServerPlayerConfiguration/url/${serverID}?type=${type}`);
    return this.get<ArrayResponse<ServerFormUrl>>(`/clients/${uuid}/serversUrlDistribution?serverID=${serverID}&serviceType=${serviceType}`);
  }
}
